export enum ChannelType {
  EMAIL = 'Mail',
  PAPER = 'Courrier',
}
